import React, { type FC } from 'react';

export const TextFields: FC = () => {
    const textFieldAImage = new URL('./text-fields-a.png', import.meta.url).toString();
    const textFieldBImage = new URL('./text-fields-b.png', import.meta.url).toString();

    return (
        <div className="text-white flex flex-col gap-4 pb-2">
            <p className="text-2xl">Text Fields</p>
            <p>
                Text fields allow template users to modify text in any text layer on a design across multiple sizes or
                variations.
            </p>
            <p>
                Click on a text layer in any frame to find the “Create New Text Field” button in the Text Layer panel.
                You can also click “+” on the “Content Fields” panel when no layer is selected to create a Text Field.
            </p>
            <img src={textFieldAImage} alt="text-field-a" />
            <p>
                You can control character limits and enable or disable text scaling for any text field to ensure content
                does not break design principles.
            </p>
            <img src={textFieldBImage} alt="text-field-b" />
        </div>
    );
};
